import { CDL_CLASSES, TRAILER_TYPES, ENDORSEMENTS, slugify } from "@/components/auth/signupConstants";

export const DriverProfileFields = ({ form, update, toggleArrayValue }) => (
  <div className="pt-2 border-t border-rr-line">
    <div className="text-xs font-bold tracking-wide uppercase text-rr-muted mb-2 mt-3">Driver profile</div>
    <div className="grid grid-cols-2 gap-3">
      <select data-testid="register-cdl-class-select" value={form.cdlClass} onChange={update("cdlClass")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm bg-white focus:outline-none focus:border-rr-orange">
        {CDL_CLASSES.map((c) => (
          <option key={c} value={c}>CDL Class {c}</option>
        ))}
      </select>
      <input data-testid="register-cdl-number-input" placeholder="CDL number" value={form.cdlNumber} onChange={update("cdlNumber")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-rr-orange" />
    </div>
    <input type="number" min="0" data-testid="register-experience-input" placeholder="Years experience" value={form.experienceYears} onChange={update("experienceYears")} className="w-full border border-rr-line rounded-lg px-4 py-3 text-sm mt-3 focus:outline-none focus:border-rr-orange" />

    <div className="mt-3">
      <div className="text-xs font-semibold text-rr-muted mb-1.5">Trailer types</div>
      <div className="flex flex-wrap gap-2">
        {TRAILER_TYPES.map((t) => (
          <button
            type="button"
            key={t}
            data-testid={`register-trailer-type-${slugify(t)}`}
            onClick={() => toggleArrayValue("trailerTypes", t)}
            className={`text-xs font-bold px-3 py-1.5 rounded-full border transition-colors ${
              form.trailerTypes.includes(t) ? "bg-rr-navy text-white border-rr-navy" : "border-rr-line text-rr-muted hover:border-rr-navy"
            }`}
          >
            {t}
          </button>
        ))}
      </div>
    </div>

    <div className="mt-3">
      <div className="text-xs font-semibold text-rr-muted mb-1.5">Endorsements</div>
      <div className="flex flex-wrap gap-2">
        {ENDORSEMENTS.map((en) => (
          <button
            type="button"
            key={en}
            data-testid={`register-endorsement-${slugify(en)}`}
            onClick={() => toggleArrayValue("endorsements", en)}
            className={`text-xs font-bold px-3 py-1.5 rounded-full border transition-colors ${
              form.endorsements.includes(en) ? "bg-rr-orange text-white border-rr-orange" : "border-rr-line text-rr-muted hover:border-rr-orange"
            }`}
          >
            {en}
          </button>
        ))}
      </div>
    </div>
  </div>
);
